<div class="contenedor-login">
  <h1>Smart Residence</h1>
  <form *ngIf="estado === ESTADOS_LOGIN.LOGIN && !cargando" [formGroup]="loginForm">
    <input formControlName="email" placeholder="Email" required>
    <input formControlName="contrasena" placeholder="Contraseña" type="password">
    <a (click)="onOlvidasteContrasena()">
      ¿Olvidaste tu contraseña?
    </a>
    <button (click)="onClickLogin()">Iniciar sesión</button>
  </form>
  
  <form *ngIf="estado === ESTADOS_LOGIN.RECUPERAR_CONTRASENA && !cargando" [formGroup]="recuperarContrasenaForm">
    <input formControlName="email" placeholder="Email para recuperar contraseña" type="email" required>
    <button (click)="recuperarContrasena()">Enviar</button>
    <a (click)="onRegresarClick()">
      Regresar
    </a>
  </form>

  <form *ngIf="estado === ESTADOS_LOGIN.NUEVA_CONTRASENA && !cargando" [formGroup]="nuevaContrasenaForm">
    <input formControlName="contrasena" placeholder="Nueva contraseña" type="password" required>
    <input formControlName="repeticionContrasena" placeholder="Repita contraseña" type="password" required>
    <div class="nueva-contrasena">Ingresa tu nueva contraseña</div>
    <button (click)="cambiarContrasena()">Enviar</button>
  </form>
  
  <div class="spinner" *ngIf="cargando">
    <mat-spinner></mat-spinner>
  </div>
</div>

